define([
    "base/utils/iamHttpService",
    "language/resource",
    "authui/iamUtils",
    "authui/iamEnv",
    "base/utils/preVerifycodeUtil",
    "base/utils/cookie",
    "base/utils/utility",
],
    function (iamHttpService, i18n, iamUtils, iamEnv, perVerifycodeUtil, cookieOp, utils) {
        "use strict";

        var upgradeCtrl = function ($scope, $sce, $filter, $interval, $timeout) {
            if (window.navigator.userAgent.toLowerCase().indexOf("hwidoauthsdk_ver") === -1) {
                document.title = i18n("hwId.upgradePageTitle");
            }

            try {
                var isOptional = iamUtils.getUrlParams()['upgradeType'] === 'optional' ? 'optional' : 'notOptional';
                iamUtils.initialCloudBI("/authui/public/custom/login.html?upgradeType=" + isOptional + "#/upgrade", { C1: "IAM-Login-" + isOptional + "-upgrade" });
            } catch (e) {
                console.dir(e)
            }

            $scope.i18n = i18n;

            $scope.model = {
                isMobile: window.outerWidth > 768 && window.navigator.userAgent.toLowerCase().indexOf("hwidoauthsdk_ver") === -1 ? false : true,
                isLiteSDK: window.navigator.userAgent.toLowerCase().indexOf("hwidoauthsdk_ver") > -1,
                agree: false, //是否同意协议
                isUpgrading: false,//开始升级
                isOptional: false,//是否可选升级
                migrateToken: iamUtils.getUrlParams()['migrateToken'],
                srcInnerUID: "",
                errorMsg: "",
                upgradeError: false,
                sdkLoading: true,
                upgradeSuccess: false,
                upgradeDescLink: iamUtils.CONFIG.upgradeDescLink,
                userAgreementLink: getUserAgreementLink(),
                privacyPolicyLink: getPrivacyPolicyLink(),
            };

            $scope.agreeClick = function () { 
                $scope.model.agree = !$scope.model.agree;
                window.scrollTo(0, document.documentElement.scrollHeight);
            }

            $scope.goUpgrade = function () {
                if (!$scope.model.agree) {
                    return;
                }
                send2CloudBISafe(iamUtils.pages.upgrade, "click_upgrade");
                $scope.model.isUpgrading = true;
                getSDKBaseInfo($scope);
            }

            $scope.cancelUpgrade = function () {
                send2CloudBISafe(iamUtils.pages.upgrade, "click_cancelUpgrade");
                if(window.navigator.userAgent.toLowerCase().indexOf("hwidoauthsdk_ver") > -1){
                    window.location.href = "https://" + 'auth.huaweicloud.com' + "/authui/appNoUpgradeLogin";
                    return;
                }
                window.location.href = "/authui/" + window.location.search;
            }

            $scope.upgradeGoBack = function () {
                window.location.reload();
            }

            initPage($scope);
        };

        // 调用authui/getSDKBaseInfo接口获取js-sdk的url及配置信息
        function getSDKBaseInfo($scope) {
            var params = {
                flowType: "migrate",
                migrateToken: $scope.model.migrateToken,
            }
            if (utils.getUrlParams().service) {
                params.service = utils.getUrlParams().service;
            }
            iamHttpService.get({
                url: "/authui/getSDKBaseInfo",
                params: params,
            }).then(function (data) {
                data = typeof data === "object" ? data : $.parseJSON(data);
                if (data.isSuccess === 1) {
                    var baseConfig = {
                        "isSuccess": "1",
                        "pageTokenKey": data.pageTokenKey,
                        "pageToken": data.pageToken,
                        "jsSdkUrl": data.jsSdkUrl,
                        "hwidConfig": data.hwidConfig
                    };
                    baseConfig.businessConf = {
                        flowType: "migrate", //迁移流程
                        clientType: $scope.model.isMobile ? "mobileWap" : "pcWeb", //手机还是pc
                        showType: "page", // 展示方式
                        migrateToken: $scope.model.migrateToken,
                        innerUid: data.innerUid,
                        srcAcctType: 1,
                        migrateSenceId: 0,
                        sucCallbackFn: function () {
                            $(".upgradeGoBack").hide();
                            $scope.model.upgradeSuccess = true;
                            if ($scope.model.isOptional) {
                                window.addEventListener('popstate', function () {
                                    history.pushState(null, null, document.URL);
                                });
                            }
                        },
                        failCallbackFn: function () {
                            $(".upgradeGoBack").hide();
                        },
                        bsFailUrl: getBsFailUrl($scope)
                    };
                    monitorSDKLoading($scope);
                    loadJsSDK(baseConfig, $scope);
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                } else {
                    $scope.model.upgradeError = true;
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }
            }, function () {
                $scope.model.upgradeError = true;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            })
        }

        // 获取js-sdk并渲染登录框
        function loadJsSDK(baseConfig, $scope) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            if (script.readyState) { // IE
                script.onreadystatechange = function () {
                    if (script.readyState === 'loaded' || script.readyState === 'complete') {
                        script.onreadystatechange = null;
                        hwidSDK.init(baseConfig);
                    }
                }
            } else { // 其他浏览器
                script.onload = function () {
                    hwidSDK.init(baseConfig);
                }
            }
            script.src = baseConfig.jsSdkUrl;
            document.getElementsByTagName('head')[0].appendChild(script);
        }

        function initPage($scope) {
            if (iamUtils.getUrlParams()['upgradeType'] && iamUtils.getUrlParams()['upgradeType'] === 'optional') {
                $scope.model.isOptional = true;
                $scope.model.agree = false;
            }
            if (!$scope.model.isOptional) {
                if (window.history && window.history.pushState) {
                    var service = utils.getUrlParams().service;
                    service !== undefined ? service = "https://auth.huaweicloud.com/authui/logout?service=" + service : service = "https://auth.huaweicloud.com/authui/logout";
                    var redirectUrl = "https://id1.cloud.huawei.com/AMW/logout" + "?service=" + service;
                    var state = {
                        title: "upgrade",
                        url: redirectUrl
                    };
                    window.history.pushState(state, "title", "#/upgrade");
                    window.addEventListener('popstate', function () {
                        if($scope.model.upgradeSuccess){
                            history.pushState(null, null, document.URL);  
                        } else {
                            localStorage.removeItem("fromUpgrade");
                            window.location.href = redirectUrl;
                        }
                    });
                    localStorage.fromUpgrade = "true";
                    window.addEventListener('keydown', function(){
                        localStorage.removeItem("fromUpgrade");
                    });
                    window.addEventListener('click', function(){
                        localStorage.removeItem("fromUpgrade");
                    });
                }
            }
            if ($scope.model.isLiteSDK) {
                if (window.webLoader && window.webLoader.setForbiddenGoBackUrl) {
                    var service = "https://auth.huaweicloud.com/authui/login.html?locale=zh-cn";
                    var redirectUrl = "https://auth.huaweicloud.com/authui/logout" + "?service=" + service;
                    window.webLoader.setForbiddenGoBackUrl(window.location.href);
                    window.goBack = function(){window.location.href = redirectUrl};
                }
            }

        }

        function send2CloudBISafe(){
            try{
                send2CloudBI.apply(null,arguments);
            }catch(e){
                console.dir(e)
            }
        }

        function monitorSDKLoading($scope) {
            var container = document.getElementById('hwidsdk_mudule_container');
            var mutationObserver = new MutationObserver(function () {
                $scope.model.sdkLoading = false;
                mutationObserver.disconnect();
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            });
            mutationObserver.observe(container, {
                childList: true,
                subtree: true,
            });
        }

        function getUserAgreementLink() {
            var link = "https://consumer.huawei.com/minisite/cloudservice/id/terms.htm" + "?branchid=1";
            link += "&language=" + window.language;
            link += "&country=" + (iamUtils.ipIsInternational() ? "HK" : "CN");
            return link;
        }

        function getPrivacyPolicyLink() {
            var link = "https://consumer.huawei.com/minisite/cloudservice/id/privacy-statement.htm" + "?branchid=1";
            link += "&language=" + window.language;
            link += "&country=" + (iamUtils.ipIsInternational() ? "HK" : "CN");
            return link;
        }

        function getBsFailUrl($scope) {
            var bsFailUrl = iamUtils.CONFIG.homepageUrl;
            if ($scope.model.isLiteSDK) {
                bsFailUrl = "https://auth.huaweicloud.com/authui/casLogin?error=1107&error_description=access+denied";
            }
            return bsFailUrl;
        }


        upgradeCtrl = ["$scope", "$sce", "$filter", "$interval", "$timeout", upgradeCtrl];
        var upgradeModule = angular.module('authui.config');
        upgradeModule.controller('authui.upgrade.ctrl', upgradeCtrl);

        return upgradeCtrl;
    });



// WEBPACK FOOTER //
// ./public/hws/js/upgrade/controllers/upgradeController.js